<template>
  <div class="layout-loading">
    <ProgressBar mode="indeterminate" />
  </div>
</template>

<style lang="scss" scoped>
.layout-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100dvh;

  .p-progressbar {
    width: 100px;
    height: 6px;
  }
}
</style>
